<template>
  <div class="full">
    <div class="container">
      <br />
      <div class="card h-96 pb-8">
        <h3
          class="
            text-center
            mt-8
            font-extrabold
            tracking-wide
            text-9xl
            font-sans
            text-black
          "
        >
          Select Host
        </h3>
        <div class="container">
          <DxScrollView
            direction="vertical"
            :scrollByContent="true"
            :scrollByThumb="true"
            ShowScrollbar="true"
            id="scroll"
            height="330px"
            width="95%"
            style="margin-left: 20px; margin-bottom: 20px"
          >
            <div
              v-for="(value, key) in usrRelatedTenant"
              class="rect bg-white rounded mt-3"
            >
            <a v-bind:href="'https://'+ value.portal_hostname + '/tc-dashboard'"
                 class="no-decoration mt-2">

              <div class="grid grid-cols-2 gap-4">
                <div class="px-6 py-2 d-flex">
                  <img
                    :src="'/imgs/host2.png'"
                    alt="error"
                    width=""
                    class="-mt-2"
                  />
                  <span class="px-6 mt-2 -mb-2">
                    <h6 class="font-semibold">{{ value.name }}</h6>
                    <p class="text-grey-dark text-sm">
                      {{ value.portal_hostname }}
                    </p>
                  </span>
                </div>
                <div
                 
                  class="flex justify-end items-center px-6"
                >
                  <i class="fas fa-chevron-right text-green-600"></i>
                </div>
              </div>
            </a>
            </div>
          </DxScrollView>
          <!-- <div class="rect  bg-white rounded mt-2">
     <h4 class="py-3  px-8">hello</h4>
     </div>
      <div class="rect  bg-white rounded mt-2">
     <h4 class="py-3  px-8">hello</h4>
     </div>
      <div class="rect  bg-white rounded mt-2">
     <h4 class="py-3  px-8">hello</h4>
     </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DxScrollView from "devextreme-vue/scroll-view";
import JetButton from "@/Jetstream/Button.vue";
import JetNavLink from "@/Jetstream/NavLink.vue";


export default {
  props: {
   usrRelatedTenant:{
      type: Array,
      default: () => [],
    },
  },

  components: {
    DxScrollView,
        JetButton,
        JetNavLink,

  },

  data() {
    return {
      Cards: [
        { name: "Product" },
        { name: "host" },
        { name: "Subscribe" },
        { name: "price" },
      ],
    };
  },
  methods: {
    goToDashboard(hostname) {
     // this.$inertia.get(route("dashboard"));

    },
  },
mounted(){
       console.log("usrRelatedTenant",this.usrRelatedTenant);

}


};
</script>

<style>
.full {
  background-color: #f6f6f6;
  height: 100vh;
  background-size: cover;
  overflow: hidden;
}

.card {
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  background-color: #f6f6f6;
  margin: 90px 120px;
}

.rect {
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  margin: 0px 100px;
  cursor: pointer;
}
p {
  margin-bottom: 0;
}
h6 {
  margin-bottom: 0.1rem;
}
/* .rect :hover{
   border: rgb(21, 245, 185);
} */
</style>